import React, { FunctionComponent } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  useTranslations,
  useAdminDeleteCompanyUser,
  useShowError,
  useCompanyUserByUuidAdmin
} from "$hooks";
import { RoutesBuilder } from "$models/RoutesBuilder";

import { AccountActivationForm } from "$components/AccountActivationForm";
import { Window } from "$components/Window";

export const DeleteCompanyUserContainer: FunctionComponent = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const { companyUuid } = useParams<{ companyUuid: string }>();
  const { adminDeleteCompanyUser } = useAdminDeleteCompanyUser();

  const history = useHistory();
  const showError = useShowError();
  const translations = useTranslations<ITranslations>("deleteCompanyUser");
  const companyUser = useCompanyUserByUuidAdmin(uuid);

  const onSubmit = async () => {
    const result = await adminDeleteCompanyUser({
      variables: { uuid, companyUuid },
      errorHandlers: {
        DeleteLastCompanyUserError: () =>
          showError({ message: translations?.deleteOnlyCompanyUserError })
      }
    });
    if (result.error) return;
    history.push(RoutesBuilder.admin.companyUsers(companyUuid));
  };

  return (
    <Window loading={!translations}>
      <AccountActivationForm
        title={`${translations?.title}\n${companyUser?.user.name} ${companyUser?.user.surname}`}
        description={translations?.description}
        submit={translations?.submit}
        onSubmit={onSubmit}
      />
    </Window>
  );
};

interface ITranslations {
  title: string;
  description: string;
  submit: string;
  deleteOnlyCompanyUserError: string;
}
